"use client"

import { useProduct } from "@/contexts/product-context"
import { useActiveScope } from "@/hooks/use-active-scope"
import type { LeoSurfaceContext } from "@/lib/leo-surface-context"
import { productLabel } from "@/lib/product-home"

/** School, program, and product label for the open workspace. */
export function useLeoWorkspaceSurface(): Pick<
  LeoSurfaceContext,
  "product" | "school" | "program"
> {
  const { product } = useProduct()
  const scope = useActiveScope(product)
  return {
    product: productLabel(product),
    school: scope.parent?.name,
    program: scope.child?.name,
  }
}
